import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=3352b6ec"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=3352b6ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports